import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

/**
 * iOS-style segmented control. The styling was previously copy-pasted for every
 * toggle group on both generator pages.
 */
const SegmentedControl = ({ label, value, onChange, options, size = 'small', sx }) => (
  <Box sx={{ mb: 1, ...sx }}>
    {label && (
      <Typography variant="body2" sx={{ mb: 0.25, fontWeight: 500, lineHeight: 1.4 }}>
        {label}
      </Typography>
    )}
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(e, next) => {
        if (next !== null) onChange(next);
      }}
      fullWidth
      size={size}
      sx={(theme) => ({
        borderRadius: '18px',
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.06)',
        padding: '2px',
        '& .MuiToggleButton-root': {
          border: 'none',
          textTransform: 'none',
          borderRadius: '16px',
          paddingTop: '4px',
          paddingBottom: '4px',
          zIndex: 1,
          position: 'relative',
          '&.Mui-selected': {
            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.16)' : 'white',
            color: 'text.primary',
            boxShadow:
              theme.palette.mode === 'dark'
                ? '0 2px 4px rgba(0, 0, 0, 0.4)'
                : '0 2px 4px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.16)' : 'white'
            }
          },
          '&:not(.Mui-selected)': {
            backgroundColor: 'transparent',
            color: 'text.secondary',
            transition: 'color 0.2s ease',
            '&:hover': {
              backgroundColor:
                theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.04)',
              borderRadius: '12px'
            }
          }
        }
      })}
    >
      {options.map((option) => (
        <ToggleButton key={option.value} value={option.value} title={option.title}>
          {option.icon || option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  </Box>
);

export default SegmentedControl;
